/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AssistantMemory = {
  /**
   * The assistant ID owning the memory.
   */
  assistantId: string;
  /**
   * The memory content.
   */
  content: string;
  /**
   * Creation timestamp.
   */
  createdAt: Date;
  /**
   * Timestamp at which the memory was soft-deleted.
   */
  deletedAt?: Date | undefined;
  /**
   * The assistant memory ID.
   */
  id: string;
  /**
   * Timestamp of the most recent access.
   */
  lastAccess: Date;
  /**
   * Timestamp at which the memory was superseded by another memory.
   */
  supersededAt?: Date | undefined;
  /**
   * The ID of the memory this one supersedes, if any.
   */
  supersedesId?: string | undefined;
  /**
   * Tags associated with the memory.
   */
  tags: Array<string>;
  /**
   * Last update timestamp.
   */
  updatedAt: Date;
  /**
   * Timestamp at which the memory becomes valid.
   */
  validAt: Date;
};

/** @internal */
export const AssistantMemory$inboundSchema: z.ZodMiniType<
  AssistantMemory,
  unknown
> = z.pipe(
  z.object({
    assistant_id: z.string(),
    content: z.string(),
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    deleted_at: z.optional(
      z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
    ),
    id: z.string(),
    last_access: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    superseded_at: z.optional(
      z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
    ),
    supersedes_id: z.optional(z.string()),
    tags: z.array(z.string()),
    updated_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    valid_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "assistant_id": "assistantId",
      "created_at": "createdAt",
      "deleted_at": "deletedAt",
      "last_access": "lastAccess",
      "superseded_at": "supersededAt",
      "supersedes_id": "supersedesId",
      "updated_at": "updatedAt",
      "valid_at": "validAt",
    });
  }),
);

export function assistantMemoryFromJSON(
  jsonString: string,
): SafeParseResult<AssistantMemory, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AssistantMemory$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AssistantMemory' from JSON`,
  );
}
